import React from 'react';
import { X } from 'lucide-react';
export function FailedApproaches() {
  const failures = [{
    title: 'Dietas de 800 calorías',
    desc: 'Elevan el cortisol y hacen que el cuerpo retenga más líquido por miedo a la hambruna.'
  }, {
    title: 'Ejercicio intenso (HIIT/Running)',
    desc: 'Cuando ya estás estresado, añade gasolina al fuego de la inflamación.'
  }, {
    title: 'Beber galones de agua',
    desc: "Sin los minerales correctos solo 'lava' tus células, empeorando la hinchazón en los tejidos."
  }, {
    title: "Jugos 'detox' azucarados",
    desc: 'Irritan tu barrera intestinal y disparan la insulina, bloqueando la quema de grasa.'
  }];
  return <section className="bg-off-white py-20 px-4" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="text-center mb-16" data-id="element-3">
          <h2 className="text-3xl md:text-4xl text-near-black mb-4" data-id="element-4">
            Por qué lo que has intentado no funciona
          </h2>
          <p className="text-lg font-sans text-gray-600 max-w-2xl mx-auto" data-id="element-5">
            Estás tratando un problema hormonal y de estrés con soluciones de
            pérdida de peso tradicionales.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-6">
          {failures.map((item, index) => <div key={index} className="flex items-start p-6 bg-white border border-gray-100 shadow-sm transition-all hover:shadow-md" data-id="element-7">
              <div className="flex-shrink-0 mr-4 mt-1" data-id="element-8">
                <div className="w-8 h-8 rounded-full bg-red-50 flex items-center justify-center" data-id="element-9">
                  <X className="w-5 h-5 text-red-400" data-id="element-10" />
                </div>
              </div>
              <div data-id="element-11">
                <h3 className="text-xl font-serif text-near-black mb-2" data-id="element-12">
                  {item.title}
                </h3>
                <p className="font-sans text-gray-600 leading-relaxed" data-id="element-13">
                  {item.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}